<template>
  <div class="do_update_work">
    <h2 class="title_com">做作业</h2>
    <section class="pd2430">
      <div class="box">
        <div class="work_type">
          <el-tag class="mr-10">{{ data_schedule.work_type_name }}</el-tag>
          <el-tag class="mr-10">{{
            data_schedule.work_put_object_name
          }}</el-tag>
          <span>{{ data_schedule.title }}</span>
        </div>
        <div class="time">
          <span class="fw600">时间：</span>
          <span>{{ data_schedule | filterTime }}</span>
          <span class="fw600">隶属：</span>
          <span>{{ data_schedule.sub_name }}</span>
        </div>
        <div class="request">
          <span class="fw600">作业具体要求：</span>
          <span> {{ data_schedule.work_require }}</span>
        </div>
        <!-- 文件下载预览 -->
        <ul class="file_review">
          <li v-for="(item, index) in data_schedule.file_info" :key="index">
            <span>{{ item.savename }}</span>
            <a :href="item.savepath" class="mr-10 a_line">下载</a>
            <a href="javascript:;" class="a_line" @click="handlePreview(item)"
              >预览</a
            >
            <!-- <span @click="handlePreview(item.savepath)">预览</span> -->
          </li>
        </ul>
      </div>
      <!-- form -->
      <el-form
        :model="workForm"
        :rules="rules"
        ref="ruleForm"
        label-width="72px"
        class="demo-ruleForm input_cls"
      >
        <el-form-item label="标题：" prop="title" class="title">
          <el-input
            v-model="workForm.title"
            placeholder="请输入标题"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="内容："
          prop="desc"
          class="desc"
          v-if="data_schedule.work_put_way !== 2"
        >
          <el-input
            resize="none"
            type="textarea"
            placeholder="请输入文字"
            v-model="workForm.desc"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 文件上传 -->
        <el-form-item
          label="文件："
          prop="files"
          class="work_file"
          v-if="data_schedule.work_put_way !== 1"
        >
          <dc-upload
            v-if="isOk"
            class="avatar-uploader"
            ref="upload"
            :dcAutoUpload="true"
            dcdom="sfs01"
            :dcConfig="dcConfig"
            @dc-success="dcSuccess"
            :on-remove="fileRemove2"
            :before-upload="beforeUpload"
            v-model="workForm.fileArr"
            :accept="uploadType"
            progressType="line"
            :show-file-list="false"
          >
            <div class="selecte_file main-bgc">
              <i class="dc-iconfont dc-icon-shangchuan mr-10"></i>
              <span>上传文件</span>
            </div>
            <div class="upload_txt" slot="tip">
              <div class="file_type">
                <span>限提交文件类型：</span>
                <span>{{ data_schedule.work_put_limit_name }}</span>
              </div>
              <div class="file_num">
                <span>限提交文件总数量：</span>
                <span>大于等于{{ data_schedule.work_put_limit_num }}个。</span>
              </div>
            </div>
            <!-- 上传列表 -->
            <ul
              class="el-upload-list el-upload-list--text"
              slot="tip"
              style="width: 65%"
            >
              <li
                tabindex="0"
                class="el-upload-list__item my_flex is-"
                v-for="(item, key) in workForm.fileArr"
                :key="key"
              >
                <a class="el-upload-list__item-name">
                  <i class="el-icon-document"></i>{{ item.savename }}</a
                >
                <div class="c-999">
                  <span
                    class="edit-name-preview mr-10 pointer"
                    @click="handlePreview(item)"
                    >预览</span
                  >
                  <span
                    class="edit-name-download mr-10 pointer"
                    @click="handleDownload(item.savepath)"
                    >下载</span
                  >
                  <span
                    class="el-icon-error del_cls pointer"
                    @click="fileRemove2(item)"
                  ></span>
                </div>
              </li>
            </ul>
            <!-- accept=".mpeg,.avi,.navi,.asf,.mov,.3gp.,.wmv,.divx,.xvid,.rm,.rmvb,.f4v,.flv,.mp4" -->
          </dc-upload>
        </el-form-item>
        <el-form-item class="commit">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button @click="cancelForm">取消</el-button>
        </el-form-item>
      </el-form>
    </section>
    <!-- 视频预览dialog -->
    <IndexPlay :row="scheduleLab" ref="playRef"></IndexPlay>
  </div>
</template>

<script>
import {
  GetKey_Url,
  WorkDetail,
  CommitWork,
  previewOffice,
  UpdateWorkApi,
  UPloadFileApi,
} from "@/api/student";
import { isFileExtVideo } from "@/filters/index";
export default {
  data() {
    let validateFiles = (rule, value, callback) => {
      if (
        this.workForm.fileArr.length < this.data_schedule.work_put_limit_num
      ) {
        callback(new Error(`需要上传大于等于${this.data_schedule.work_put_limit_num}个文件`));
      }else{
        callback();
      }
    };
    return {
      workForm: {
        title: "",
        fileArr: [],
      },
      rules: {
        title: [{ required: true, message: "请输入作业标题", trigger: "blur" }],
        files:[{ validator: validateFiles, trigger: 'blur', required: true }]
      },
      isOk: false, // 先请求到key和url再加载upload这个dom元素
      dcConfig: {
        key: "",
        notify_url: "",
      }, //后台的key和notify_url接口地址
      workId: "",
      path: "",
      data_schedule: {}, //做业内容
      user_data: {}, // 我的作业内容
      //   fileList: [], // 文件列表
      scheduleLab: {},
      uploadType: "",
    };
  },
  methods: {
    // 文件类型转换
    changeFileType() {
      let arr = this.data_schedule.work_put_limit;
      if (arr.includes(5)) {
        this.uploadType = "";
        return;
      }
      if (arr.includes(1)) {
        this.uploadType += ".jpg,.jpeg,.png,.bmp,.gif,";
      }
      if (arr.includes(2)) {
        this.uploadType += ".docx,.doc,";
      }
      if (arr.includes(3)) {
        this.uploadType += ".pptx,.ppt,";
      }
      if (arr.includes(4)) {
        this.uploadType += ".mp4,.mpg,.mpeg,.flv,.avi,.rm,.rmvb,.wmv,.3gp,.MP4";
      }
    },
    // 下载
    handleDownload(file) {
      this.downloadFile(file);
    },
    // 预览
    handlePreview(row) {
      //   if (!row.file_info) {
      //     this.messageTips("该文件暂无链接!","");
      //     return false;
      //   }
      if (isFileExtVideo(row.ext)) {
        this.scheduleLab = row;
        this.$nextTick(function () {
          this.$refs.playRef.handleUpdate();
        });
      } else {
        previewOffice({ url: row.savepath }).then((res) => {
          window.open(res);
        });
      }
    },

    // // 文件预览
    // handlePreview(file) {
    //   previewOffice({ url: file }).then((res) => {
    //     window.open(res);
    //   });
    // },
    // 删除文件
    fileRemove2(file) {
      // 找到删除的文件
      let obj = this.workForm.fileArr.find((item) => {
        return item.id == file.id;
      });
      let idx = this.workForm.fileArr.indexOf(obj);
      this.workForm.fileArr.splice(idx, 1);
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 文件id数组
          let arr = this.workForm.fileArr.map((item) => {
            return item.id;
          });
          //   let str = arr.join(",");
          // 作业修改
          if (this.path === "/UpdateWork") {
            CommitWork({
              work_content: this.workForm.desc,
              schedule_id: this.workId, // 答题id
              work_require_attachment: arr,
              work_title: this.workForm.title.trim(),
            }).then((res) => {
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
              setTimeout(() => {
                this.$router.go(-1);
              }, 1500);
            });
          } else {
            //提交作业
            CommitWork({
              work_content: this.workForm.desc,
              schedule_id: this.workId,
              work_require_attachment: arr,
              work_title: this.workForm.title.trim(),
            }).then((res) => {
              this.$message({
                showClose: true,
                message: "提交成功",
                type: "success",
              });
              setTimeout(() => {
                // this.$router.go(-1);
                this.$router.push({ path: "/StudentWork"});
              }, 1500);
            });
          }
        }
      });
    },
    // 取消
    cancelForm() {
      this.$router.go(-1);
    },
    // 金山云上传成功的回调
    dcSuccess(data) {
      //   console.log(data);
      // this.loading = true;
      let eTag = data.upload.CompleteMultipartUploadResult.ETag;
      // 去掉字符串的双引号
      eTag = eTag.replace(/"/g, "");
      UPloadFileApi({ etag: eTag }).then((res) => {
        // let temp = {
        //   id: res.data.id,
        //   name: res.data.savename,
        // };
        this.workForm.fileArr.push(res.data);
        this.$refs["ruleForm"].validate("files");
      });
    },
    // 删除文件
    fileRemove(file) {
      // 截取文件名
      let index = file.name.indexOf(".");
      let fileName = file.name.slice(0, index);
      // 找到删除的文件
      let obj = this.workForm.fileArr.find((item) => {
        return item.name == fileName;
      });
      let idx = this.workForm.fileArr.indexOf(obj);
      this.workForm.fileArr.splice(idx, 1);
    },
    // 文件上传之前
    beforeUpload(file) {
      console.log(file, "290");
      // if (
      //   this.workForm.fileArr.length >= this.data_schedule.work_put_limit_num
      // ) {
      //   this.messageTips(
      //     `最多只能上传${this.data_schedule.work_put_limit_num}个文件`,
      //     "warning"
      //   );
      //   return false;
      // }
      return true;
    },
    createFn() {},
  },
  filters: {
    // 过滤时间
    filterTime(val) {
      if (val.start_date == "-" && val.end_date == "-") {
        return "————";
      } else if (val.start_date && val.end_date) {
        let startArr = val.start_date.split(" ");
        let endArr = val.end_date.split(" ");
        let str = `${startArr[0]} ${startArr[1]}-${endArr[1]}`;
        return str;
      }
    },
  },
  created() {
    this.workId = this.$route.query.workId;
    this.path = this.$route.path;
    // 获取key与回调url
    GetKey_Url().then((res) => {
      this.getKey_UrlData = res.data;
      this.dcConfig.key = this.getKey_UrlData.key;
      this.dcConfig.notify_url = this.getKey_UrlData.notify_url;
      // 先请求到key和url再加载upload这个dom元素
      this.isOk = true;
    });
    // 作业详情
    if (this.workId) {
      WorkDetail({ id: this.workId }).then((res) => {
        let { data_schedule, user_data } = res.data;
        this.data_schedule = data_schedule;
        // 文件显示格式
        this.changeFileType();
        //   console.log(this.data_schedule,'252');
        this.user_data = user_data;
        // 修改作业回显
        if (user_data.length !== 0) {
          this.$set(this.workForm, "title", user_data[0].work_title);
          this.$set(this.workForm, "desc", user_data[0].work_content);
          if (user_data[0].file) {
            // 文件列表
            this.workForm.fileArr = user_data[0].file;
          }
        }
      });
    }
  },
};
</script>
 
<style lang = "less" scoped>
.do_update_work {
  background-color: #fff;
  section {
    .box {
      .file_review {
        padding: 10px 0 24px;
        li {
          margin-right: 20px;
          padding-bottom: 10px;
          span {
            margin-right: 10px;
          }
          a {
            color: #3489ff;
          }
        }
      }
      .time {
        /* line-height: 30px; */
        padding: 10px 0;
        span {
          &:nth-child(2) {
            margin-right: 50px;
          }
        }
      }
      .request {
        line-height: 24px;
      }
      .work_type {
        .el-tag {
          color: #999;
          background-color: #fff;
          border: 1px solid #999;
        }
      }
    }
    /deep/ .el-form {
      .el-form-item {
        margin-bottom: 28px;
      }
      .title {
        .el-input__inner {
          width: 400px;
        }
      }
      .desc {
        .el-textarea__inner {
          width: 600px;
          height: 200px;
        }
      }
      .selecte_file {
        width: 110px;
        color: #fff;
        border-radius: 4px;
      }
      .upload_txt {
        .file_num {
          text-align: left;
          line-height: 20px;
        }
      }
      .commit {
        .el-button {
          width: 100px;
        }
      }
      .work_file {
        li {
          span {
            &:hover {
              color: #3489ff;
            }
          }
        }
        .del_cls {
          &:hover {
            color: #ed5565;
          }
        }
      }
    }
  }
}
</style>